import {
  ListedCompany,
  useStockTickerListQuery
} from 'generated/graphql';
import { useMemo } from 'react';



export interface IData {
  tickers: Pick<ListedCompany, 'id' | 'ticker' | 'isFavorite'>[];
}

export function useQuery({
  limit, offset, ticker
}: {
  ticker: string;
  limit: number;
  offset: number;
}) {
  const tuple = useStockTickerListQuery({
    variables: {
      options: {
        paginationInput: {
          limit: limit,
          offset: offset
        },
        filter: {
          ticker: ticker || undefined,
          timeFrame: 'oneYear'
        }

      }
    },
    returnPartialData: true
  });

  return useMemo(
    () => {
      const data: IData = {
        tickers: tuple.data?.listedCompanies.map((n) => ({
          id: n.id,
          ticker: n.ticker,
          isFavorite: n.isFavorite
        })) ?? []
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}

